import React from "react";
import {useTranslation} from "react-i18next";
import parse from "html-react-parser";
const TermsAndConditions = ({ darkTheme }) => {
  const {t} = useTranslation();
  return (
    <div
      id="terms-policy"
      className="modal fade"
      role="dialog"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div
          className={
            "modal-content " + (darkTheme ? "bg-dark-2 text-light" : "")
          }
        >
          <div className="modal-header">
            <h3 className={"modal-title " + (darkTheme ? "text-white" : "")}>
                {t("footer.privacy_policy.title")}
            </h3>
            <button
              type="button"
              className={"btn-close " + (darkTheme ? "btn-close-white" : "")}
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body p-4">
            <h5 className={"mb-3 mt-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              {t("footer.privacy_policy.subtitle1")}
            </h5>
            {parse(t("footer.privacy_policy.subtitle1_content"))}
            <h5 className={"mb-3 mt-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              {t("footer.privacy_policy.subtitle2")}
            </h5>
            {parse(t("footer.privacy_policy.subtitle2_content"))}
            <h5 className={"mb-3 mt-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              {t("footer.privacy_policy.subtitle3")}
            </h5>
            {parse(t("footer.privacy_policy.subtitle3_content"))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
